
import "./Loading.css"

export function Loading({}) {
  return (
    <div className="loader" />
  );
}
